<template>
    <div class="content">
        <div class="content-head">
            <div class="content-head-title">搜索</div>
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="是否展示分组客户">
                    <el-checkbox v-model="params.IsUniformCodeAmount"></el-checkbox>
                </el-form-item>
                <el-form-item label="客户名称">
                    <el-input v-model="params.Credit_Customer_Name" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="客户编号">
                    <el-input v-model="params.Credit_Customer_Code" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="统一编号">
                    <el-input v-model="params.Credit_Customer_UniformCode" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="getCreditCustomers(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onRefresh" icon="el-icon-refresh" :loading="loadingBtn">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-table">
            <div class="content-table-title">
                系统列表
                <el-dropdown trigger="click">
                    <el-button type="primary">
                        导出
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>
                            <span @click="getCreditCustomerExport()">导出查询信息</span>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <el-table :data="tabledata" :height="maxheight" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" v-loading="loadingBtn">
                <el-table-column prop="Credit_Customer_ID" label="ID" align="center" width="120" fixed="left"></el-table-column>
                <el-table-column prop="Credit_Customer_Name" show-overflow-tooltip label="客户名称" align="left"></el-table-column>
                <el-table-column prop="Credit_Customer_Code" label="客户编号" align="center" width="180"></el-table-column>
                <el-table-column prop="Credit_Customer_UniformCode" label="统一编号" align="center" width="180"></el-table-column>
                <el-table-column prop="BlackState" label="加入付款受限" align="center" width="180"></el-table-column>
                <el-table-column prop="IsLimited" label="付款受限" align="center" width="150"></el-table-column>
                <el-table-column prop="IsCodeLimited" label="动态码受限" align="center" width="150"></el-table-column>
                <el-table-column prop="Score" label="评分" align="center" width="150"></el-table-column>
                <el-table-column prop="Credit_AgentScore_OverdueReturnScore" label="操作" align="center" width="200" fixed="right">
                    <template slot-scope="scope">
                        <div class="operation-bar">
                            <span class="operation-bar-block" v-if="scope.row.AddBlack === 'true'" @click="handlePaymentAddopen(scope.row)">加入付款受限</span>
                            <span class="operation-bar-block" v-if="scope.row.Edit === 'true'" @click="handleopenEdit(scope.row)">修改</span>
                            <span class="operation-bar-block" @click="handleopenEdit(scope.row, true)">查看</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>

        <el-dialog title="加入受限名单" :visible.sync="isPaymentAdd" width="1200px" :before-close="handleisPaymentAddClose" :close-on-click-modal="false">
            <div class="payment">
                <el-row :gutter="20">
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">客户名称：</div>
                            <div></div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">项目类型：</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">统一编号：</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">
                                <span class="required">*</span>
                                原因：
                            </div>
                            <div>
                                <el-input v-model="remarks" clearable class="el-select-big" placeholder=""></el-input>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center">
                <el-button @click="handleisPaymentAddClose()">取消</el-button>
                <el-button type="primary" @click="getAddCreditCustomerBlacklist()">保存</el-button>
            </span>
        </el-dialog>

        <el-dialog title="信控客户信息" :visible.sync="isCustomerinformation" width="1200px" :before-close="handleisCustomerinformationClose" :close-on-click-modal="false">
            <div class="payment">
                <el-row :gutter="20">
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">客户名称：</div>
                            <div>{{ details.Credit_Customer_Name }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">客户编号：</div>
                            <div>
                                {{ details.Credit_Customer_Code }}
                            </div>
                        </div>
                    </el-col>

                    <el-col :span="24" v-if="viewDeails">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">统一编号：</div>
                            <div>
                                {{ details.Credit_Customer_UniformCode }}
                            </div>
                        </div>
                    </el-col>

                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">是否加入受限名单：</div>
                            <div>{{ details.Credit_Customer_IsBlacklist ? '是' : '否' }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24" v-if="viewDeails">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">动态码受限：</div>
                            <div>{{ details.Credit_Customer_IsBlacklist ? '是' : '否' }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">添加时间：</div>
                            <div>{{ details.Credit_Customer_Addtime }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">最后更新时间：</div>
                            <div>{{ details.Credit_Customer_Updatetime }}</div>
                        </div>
                    </el-col>

                    <el-col :span="24" v-if="viewDeails">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">最近七日评分：</div>
                            <div>
                                <div style="text-align: right">
                                    <el-button type="primary" @click="getMoreratings()" style="margin-top: 10px; margin-bottom: 10px">更多评分</el-button>
                                </div>
                                <el-table :data="ratingList" border :header-cell-style="{ backgroundColor: '#F5F7FA' }" style="width: 1000px">
                                    <el-table-column prop="Credit_MarkScore_InitialAmount" label="基本合作规模" align="center" width="120"></el-table-column>
                                    <el-table-column prop="Credit_MarkScore_LawyerLetterAmount" label="律师函调整额" width="120" show-overflow-tooltip align="center"></el-table-column>
                                    <el-table-column prop="Credit_MarkScore_ReminderLetterAmount" label="催款函调整额" align="center" width="120"></el-table-column>
                                    <el-table-column prop="Credit_MarkScore_RepaymentPlanAmount" label="还款计划调整额" align="center" width="130"></el-table-column>
                                    <el-table-column prop="Credit_MarkScore_InitialScore" label="基本得分" align="center" width="100"></el-table-column>
                                    <el-table-column prop="Credit_MarkScore_OverdueReturnScore" label="客户逾期欠款调整分" align="center" width="130"></el-table-column>
                                    <el-table-column prop="Credit_MarkScore_OnTimeRateScore" label="书面计划完成率调整分" align="center" width="150"></el-table-column>
                                    <el-table-column prop="Credit_MarkScore_WrittenScore" label="书面确认调整分" align="center" width="150"></el-table-column>
                                    <el-table-column prop="Credit_MarkScore_CommercialBillScore" label="商业承兑汇票调整分" align="center" width="150"></el-table-column>
                                    <el-table-column prop="Credit_MarkScore_TotalScore" label="最终得分" align="center" width="150"></el-table-column>
                                    <el-table-column prop="Credit_MarkScore_Addtime" label="评分日期" align="center" width="150"></el-table-column>
                                    <el-table-column prop="Credit_MarkScore_Evaluation" label="评分评价" align="center" width="150"></el-table-column>
                                    <el-table-column prop="Credit_MarkScore_IsReturnZero" label="评分归零" align="center" width="150"></el-table-column>
                                    <el-table-column prop="Credit_MarkScore_Remarks" label="归零项备注" align="center" width="150"></el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </el-col>

                    <el-col :span="24" v-if="!viewDeails">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">
                                <span class="required">*</span>
                                变更客户统一编号：
                            </div>
                            <div>
                                <el-input v-model="details.Credit_Customer_UniformCode" clearable class="el-select-big" placeholder=""></el-input>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="24" v-if="!viewDeails">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">动态码受限：</div>
                            <div>
                                <el-radio v-model="details.Credit_Customer_CodeLimit" :label="1">是</el-radio>
                                <el-radio v-model="details.Credit_Customer_CodeLimit" :label="0">否</el-radio>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center" v-if="viewDeails">
                <el-button @click="handleisCustomerinformationClose()">返回</el-button>
            </span>
            <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center" v-else>
                <el-button @click="handleisCustomerinformationClose()">取消</el-button>
                <el-button type="primary" @click="getEditCreditCustomer()">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import Pagination from '@/components/Pagination.vue';
import { myMixin } from '@/utils/mixin.js';
import { downloadFile, toLowerCaseKeys } from '@/utils/utils.js';
import { cloneDeep } from 'lodash';
export default {
    name: 'creditControlcustomer',
    mixins: [myMixin],
    components: {
        Pagination
    },
    data() {
        return {
            loadingBtn: false,
            isPaymentAdd: false,
            isCustomerinformation: false,
            viewDeails: false,
            remarks: '',
            uniformcode: '',
            details: {
                Credit_Customer_Addtime: '',
                Credit_Customer_Code: '',
                Credit_Customer_CodeAuditLimit: 0,
                Credit_Customer_CodeLimit: 0,
                Credit_Customer_CodeLimitAuto: 0,
                Credit_Customer_ID: 0,
                Credit_Customer_IsBlacklist: 0,
                Credit_Customer_Name: '',
                Credit_Customer_UniformCode: '',
                Credit_Customer_Updatetime: ''
            },
            params: {
                IsUniformCodeAmount: false,
                Credit_Customer_Name: '',
                Credit_Customer_Code: '',
                Credit_Customer_UniformCode: ''
            },
            ratingList: [],
            tabledata: []
        };
    },
    mounted() {
        this.getCreditCustomers();
    },
    methods: {
        /*
     重置
   */
        onRefresh() {
            (this.params = {
                IsUniformCodeAmount: '',
                Credit_Customer_Name: '',
                Credit_Customer_Code: '',
                Credit_Customer_UniformCode: ''
            }),
                this.getCreditCustomers(true);
        },
        /*
     查询列表
   */
        getCreditCustomers(flag = false) {
            this.loadingBtn = true;
            if (flag) {
                this.paginationOptions = {
                    Page: 1,
                    total: 0,
                    PageSize: 40
                };
            }
            this.$newsApi
                .getCreditCustomers(this.filteropt())
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.tabledata = res.data.data;
                        this.paginationOptions.total = res.data.RecordCount;
                    } else {
                        this.tableData = [];
                        this.paginationOptions.total = 0;
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        /*
     查询列表
   */
        filteropt() {
            let params = cloneDeep(this.params);
            params.IsUniformCodeAmount = this.params.IsUniformCodeAmount ? '1' : '';
            console.log(params, 'params');
            return { json: JSON.stringify(toLowerCaseKeys(params)), Page: this.paginationOptions.Page, PageSize: this.paginationOptions.PageSize };
        },
        /*
    导出查询列表结果
  */
        getCreditCustomerExport() {
            this.$newsApi
                .getCreditCustomerExport(this.filteropt())
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        downloadFile(res.data.data, res.data.Resultinfo);
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.getCreditCustomers();
        },
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getCreditCustomers();
        },

        handlePaymentAddopen(row) {
            this.getAddCreditCustomerBlackCheck(row.Credit_Customer_ID);
        },
        getAddCreditCustomerBlackCheck(id) {
            this.$newsApi.getAddCreditCustomerBlackCheck({ id }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.isPaymentAdd = true;
                }
            });
        },
        /*
    加入黑名单
    */
        getAddCreditCustomerBlacklist(id) {
            this.$newsApi.getAddCreditCustomerBlacklist({ id }).then((res) => {
                if (res.data.Resultcode == 0) {
                    console.log(res.data);
                }
            });
        },
        /*
    修改变更编号
    */
        getEditCreditCustomer(id) {
            this.$newsApi.getEditCreditCustomer({ id }).then((res) => {
                if (res.data.Resultcode == 0) {
                    console.log(res.data);
                }
            });
        },
        /*
    信控客户系统详情
    */
        getCreditCustomerByID(id) {
            this.$newsApi.getCreditCustomerByID({ id }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.details = res.data.data;
                    if (this.viewDeails) {
                        this.getCreditMarkScoreByUniformCode(this.details.Credit_Customer_UniformCode);
                    }
                    this.isCustomerinformation = true;
                }
            });
        },
        getCreditMarkScoreByUniformCode(uniformcode) {
            this.$newsApi.getCreditMarkScoreByUniformCode({ uniformcode, Number: 7 }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.ratingList = res.data.data;
                }
            });
        },
        getMoreratings() {
            this.$router.push('/creditControlproject/customerDailyrating');
        },
        handleisCustomerinformationClose() {
            this.isCustomerinformation = false;
        },
        handleisPaymentAddClose() {
            this.isPaymentAdd = false;
        },
        handleopenEdit(items, flag = false) {
            this.viewDeails = flag;
            this.getCreditCustomerByID(items.Credit_Customer_ID);
        }
    }
};
</script>
<style lang="scss" scoped>
.required {
    color: red;
    margin-left: 4px;
}
.hw-form-item {
    padding: 10px 0;
    display: flex;
    align-items: center;

    &-label {
        text-align: right;
        width: 140px;
    }
}
</style>
